import { useDispatch } from 'react-redux';

import { closeDialogAction, openDialogAction, updateDialogPropsAction } from 'store/entities/ui/slice';

export const useDialog = () => {
  const dispatch = useDispatch();

  const openDialog = (variant, props) => {
    dispatch(openDialogAction({ variant, props }));
  };

  const closeDialog = () => {
    dispatch(closeDialogAction());
  };

  const updateDialogProps = (props) => {
    dispatch(updateDialogPropsAction(props));
  };

  return { openDialog, closeDialog, updateDialogProps };
};
